// 数字转换为万单位
export function formatNumber (num) {
  num = Number(num)
  if (num === 0) {
    return num + ''
  } else if (num > 1 && num < 10000) {
    return num + ''
  } else {
    return (num / 10000).toFixed(2) + '万'
  }
}
